import { render, staticRenderFns } from "./ArticulosListAdmin.vue?vue&type=template&id=3eb9ba9c&scoped=true&"
import script from "./ArticulosListAdmin.vue?vue&type=script&lang=js&"
export * from "./ArticulosListAdmin.vue?vue&type=script&lang=js&"
import style0 from "./ArticulosListAdmin.vue?vue&type=style&index=0&id=3eb9ba9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb9ba9c",
  null
  
)

export default component.exports